import React, { useEffect, useState, useRef } from "react";
import { DatePicker, Select, Form, Typography } from "antd";
import moment from "moment";

const { Option } = Select;
const { Title } = Typography;

const CreateWorkOrderTab = (props) => {
    const boxRef = useRef();
    const { showMaximumChat } = props;

    const [date, setDate] = useState(null); // State for selected date
    const [time, setTime] = useState(null); // State for selected time

    // Disable past dates
    const disabledDate = (current) => {
        // Can only select dates from today and onward
        return current && current < moment().startOf('day');
    };

    // Handle time change
    const handleTimeChange = (value) => {
        setTime(value);
    };

    // Handle date change
    const handleDateChange = (date) => {
        setDate(date);
        setTime(null); // Reset time when date changes
    };

    const handleSubmit = () => {
        const formattedDate = date ? date.format("YYYY-MM-DD") : "No Date Selected";
        const formattedTime = time ? time : "No Time Selected";

        props?.addMessages({
            selectedDate: formattedDate,
            selectedTime: formattedTime
        });
    };

    // Check if the selected date is today
    const isToday = date && date.isSame(moment(), "day");

    // Available time options
    const timeOptions = [
        { label: "10 AM to 12 PM", value: "10 AM to 12 PM", hours: 10 },
        { label: "12 PM to 3 PM", value: "12 PM to 3 PM", hours: 12 },
        { label: "4 PM to 6 PM", value: "4 PM to 6 PM", hours: 16 },
        { label: "6 PM to 8 PM", value: "6 PM to 8 PM", hours: 18 }
    ];

    // Filter time options if today is selected
    const filteredTimeOptions = isToday
        ? timeOptions.filter(option => option.hours > moment().hours())
        : timeOptions;

    return (
        <div ref={boxRef} className="box">
            <span className="error-head">CREATE WORK ORDER</span>
            <div style={{ top: "0px" }} className="error-container">
                <div
                    style={{ backgroundColor: "#eff0ee" }}
                    className="error-message-container"
                >
                    <div className="error-message-head2">
                        We are sorry for the inconvenience!
                    </div>
                    <div className="error-message-head2">
                        Visit Charges are subject to your account level warranty. Material
                        charges if applicable will be informed during the installer visit.
                    </div>
                    <div className="error-message-head2">
                        Please select your preferred date & time and we will send our
                        technician to fix this issue for you!
                    </div>

                    <div>
                        <Form style={{ width: "50%" }} layout="vertical">
                            <Title
                                style={{ fontSize: "14px" }}
                                className="error-message-head2"
                                level={4}
                            >
                                Select Date
                            </Title>
                            <Form.Item>
                                <DatePicker
                                    onChange={handleDateChange}
                                    disabledDate={disabledDate}
                                    style={{ width: "100%" }}
                                    placeholder="Select Date"
                                />
                            </Form.Item>

                            <Title
                                style={{ fontSize: "14px" }}
                                className="error-message-head2"
                                level={4}
                            >
                                Select Time
                            </Title>
                            <Form.Item>
                                <Select
                                    onChange={handleTimeChange}
                                    placeholder="Select Time"
                                    style={{ width: "100%" }}
                                    value={time}
                                >
                                    {filteredTimeOptions.length > 0 ? (
                                        filteredTimeOptions.map((option) => (
                                            <Option key={option.value} value={option.value}>
                                                {option.label}
                                            </Option>
                                        ))
                                    ) : (
                                        <Option disabled>No time available for today</Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Form>
                    </div>
                    <div style={{ display: "flex", gap: "10px" }}>
                        <button
                            className="submit-wo"
                            style={{ width: showMaximumChat ? "20%" : "25%" }}
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                        <button
                            className="cancel-wo"
                            style={{ width: showMaximumChat ? "25%" : "35%" }}
                            onClick={() => {
                                // Your cancel logic here
                            }}
                        >
                            Cancel WO
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateWorkOrderTab;
